module.exports = __webpack_public_path__ + "media/images/noticias/viejas/noti_mujer/noti_mujer_4-31bb238bcd4a6d3599f472e5a1bcfab6.jpg";